// src/useJsonLd.js

import { useEffect } from 'react';

/**
 * Injects a <script type="application/ld+json">…</script> into the document head.
 * @param {Object} jsonLd - The JSON‑LD object to serialize.
 */
export default function useJsonLd(jsonLd) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [jsonLd]);
}
